// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__3vckn","footerTop":"Footer_footerTop__NaZKV","nav":"Footer_nav__lsjY9","form":"Footer_form__-Sro5","footerBottom":"Footer_footerBottom__7Q8Hm"};